import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface CounterState {
  count: any;
  hasInstant:any
}

const initialState: CounterState = {
  count: 0,
  hasInstant:false
}

export const Slice = createSlice({
  name: 'noticeCounter',
  initialState,
  reducers: {

    summarySet: (state, action) => {
    const {count,hasInstant} = action.payload;
    state.count = count;
    state.hasInstant = hasInstant;
    
  }
  },
})

// Action creators are generated for each case reducer function
export const {  summarySet } = Slice.actions

export default Slice.reducer